import { createSelector } from 'reselect';
import { urlsWrapper } from 'config';
import { serialize } from 'utils';
import { commonDelete, commonGet, commonPost, commonPut } from './api';
import {
  createCommonListConstants,
  createCommonListReducer,
  saveData,
} from './utils';
import { getTracksByWorkrecords } from './workRecords';

const mechanizers = createCommonListConstants('MECHANIZERS');

export default createCommonListReducer(mechanizers);

const constantsMechanizersWorkrecords = createCommonListConstants(
  'MECHANIZER_WORKRECORDS'
);

export function getMechanizers() {
  return saveData(
    `${urlsWrapper('mechanizers')}`,
    mechanizers.SET_LIST,
    mechanizers.SET_IS_PENDING
  );
}

const shouldFetchMechanizers = (state) => {
  return (
    !state.mechanizers.list.length ||
    (state.currentAdvisorCustomer?.item?.id ||
      state.auth.currentCustomer?.id) !== state.mechanizers.list[0]?.customer_id
  );
};

export const fetchMechanizersIfNeeded = () => (dispatch, getState) => {
  const state = getState();
  return shouldFetchMechanizers(state)
    ? dispatch(getMechanizers())
    : Promise.resolve();
};

export const addMechanizers = (data) =>
  commonPost({
    url: `${urlsWrapper('mechanizers')}`,
    data,
  });

export const deleteMechanizers = (id) =>
  commonDelete({
    url: `${urlsWrapper('mechanizers')}/${id}`,
  });

export const updateMechanizers = (data, id) =>
  commonPut({
    url: `${urlsWrapper('mechanizers')}/${id}`,
    data,
  });

export const getMechanizersSelector = createSelector(
  [(state) => state.mechanizers.list, (state) => state.mechanizers.isPending],
  (list, isPending) => ({
    list,
    isPending,
  })
);

export const getMechanizerName = (mechanizer) => {
  if (!mechanizer) return '';
  const { last_name: lastName, first_name: firstName } = mechanizer || {};
  return [lastName, firstName].filter((v) => v).join(' ');
};

export const errorCodes = {
  WorkrecordMachineryExists: 'WorkrecordMachineryExists',
};

export const getErrorMessage = (e) => {
  if (e?.code === errorCodes.WorkrecordMachineryExists) {
    return 'Удалить механизатора нельзя, поскольку он указан в работах';
  }
  return 'Ошибка удаления механизатора';
};

export const getMechanizer = (id) =>
  commonGet({
    url: `${urlsWrapper('mechanizers')}/${id}`,
  });

export const getMechanizersWorkrecordsWithTracks =
  (machineId, params) => async (dispatch) => {
    const workrecords = await commonGet({
      url: `${urlsWrapper('mechanizers')}/${machineId}/workrecords?${serialize(
        params
      )}`,
    });
    return dispatch(
      getTracksByWorkrecords(
        { workrecords: workrecords?.data },
        constantsMechanizersWorkrecords
      )
    );
  };
